// eslint-disable-next-line import/prefer-default-export, no-shadow
export enum GeneralActionTypes {
  SetLastKnownStatus = 'SetLastKnownStatus',
}
